<!-- BR - 数据Diagnosis组件 -->
<template>
  <div
    :class="{
      'diagnosis-item-wrap': true,
      'diagnosis-item-wrap-br': true,
      'diagnosis-item-wrap-hor': direction === 'horizontal',
    }"
  >
    <div
      :id="direction === 'vertical' && data.chartkey ? `section-${data.chartkey}` : undefined"
      :class="[
        'diagnosis-item-wrap__panel',
        direction === 'vertical'
          ? 'diagnosis-item-wrap__panel--card'
          : 'diagnosis-item-wrap__panel--hor',
      ]"
    >
      <!-- 标题 -->
      <div @click="closeToolTip">
        <Title v-if="direction === 'vertical'" :data="data" />
      </div>
      <div
        v-if="tagData[data.chartkey]"
        :class="{
          'chart-mode-choose': true,
          'chart-mode-choose-br': true,
          'chart-mode-choose-hor': direction === 'horizontal',
        }"
      >
        <div
          v-for="(item, index) in tagData[data.chartkey]"
          :key="index"
          :class="{ 'mode-tag': true, 'mode-selected': index === currentMode }"
          @click="chooseMode(index)"
        >
          <p>{{ item.name }}</p>
        </div>
      </div>
      <!-- 指标 -->
      <Advertise
        v-if="data.chartkey === 'promotion' && currentMode === 2"
        :advertise-item="advertiseItem"
        @advertiseSelect="advertiseSelect"
      />
      <div v-else @click="closeToolTip">
        <Indicators
          :key="currentMode"
          :data="getIndicators"
          :direction="direction"
          :show-compare-info="showCompareInfo"
        />
      </div>
      <!-- top10菜品 -->
      <!-- 如果点到了菜品区域，也关闭tooltip -->
      <TopItems
        v-if="data.chartkey === 'menu'"
        :item-data="data.itemTop10"
        :period="period"
        @click="closeToolTip"
      />
      <!-- 图表 -->
      <ModesChart
        v-if="data.chartData && !(data.chartkey === 'promotion' && currentMode === 2)"
        ref="charts"
        :options="data.chartData"
        :height="data.chartHeight"
        :direction="direction"
        :chartkey="data.chartkey"
        :hidden-series-names="hiddenSeriesNames"
        :legend-selected-map="legendSelectedMap"
        @showHorCharts="showHorCharts"
        @changeChartMode="changeChartMode"
      />
      <!-- 自定义的底部legend -->
      <div @click="closeToolTip">
        <DiagnosisLegendBR
          v-if="showCustomLegend"
          ref="legend"
          :items="currentLegendItems"
          :active="legendActive"
          :direction="direction"
          :collapsed="legendCollapsed"
          :has-overflow="legendHasOverflow"
          :collapsed-height="legendCollapsedHeight"
          :show-collapse="showLegendCollapse"
          @toggle="handleLegendToggle"
          @toggle-collapse="toggleLegendCollapse"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/pages-v2/ShopDetail/components/DiagnosisCommon/components/DiagnosisItemCommon/title/index.vue'
import TopItems from '@/pages-v2/ShopDetail/components/DiagnosisCommon/components/DiagnosisItemCommon/TopItems/index.vue'
import Indicators from './Indicators/index.vue'
import Advertise from './Indicators/advertise.vue'
import ModesChart from './ModesChart/index.vue'
import DiagnosisLegendBR from './Legend/index.vue'
import { chartKeyForHorShow, normalRoleChartKeyForHorShow } from './../../utils/builderBR.js'
import EventBus from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/eventBus'
import { checkIsFullIndicators } from '../../utils/transformerBR/index'

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Title,
    Indicators,
    ModesChart,
    TopItems,
    Advertise,
    DiagnosisLegendBR,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    showCompareInfo: {
      type: Boolean,
      default: false,
    },
    period: {
      type: String,
      default: '',
    },
    periodOptions: {
      type: Array,
      default: () => [],
    },
    periodValue: {
      type: [String, Number],
      default: '',
    },
    // 是否为完整权限版块的图表页面
    isFullChart: {
      type: Boolean,
      default: false,
    },
    advertiseItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentMode: 0,
      legendActive: [true, true, true, true],
      legendCollapsed: true,
      legendHasOverflow: false,
      legendCollapsedHeight: 0,
    }
  },
  computed: {
    showCustomLegend() {
      return (
        ['users', 'service', 'promotion'].includes(this.data.chartkey) &&
        this.currentLegendItems.length
      )
    },
    showLegendCollapse() {
      return this.direction === 'vertical'
    },
    currentLegendItems() {
      return this.data.chartData?.[this.currentMode]?.legendItems || this.data.legendItems || []
    },
    hiddenSeriesNames() {
      // 自定义 legend 只控制柱状系列显隐，用于同步图表圆角和选中态描边计算
      // 筛选出被隐藏的柱状图
      return this.currentLegendItems
        .filter((item, index) => !this.legendActive[index] && item.type === 'bar')
        .map(item => item.name)
    },
    legendSelectedMap() {
      // 改为受控 legend selected，避免直接 dispatchAction 后图表内部状态和外层 legend 状态不一致
      return this.currentLegendItems.reduce((result, item, index) => {
        result[item.name] = this.legendActive[index] !== false
        return result
      }, {})
    },
    getIndicators() {
      let indicators = this.data.indicators || []

      if (this.data.chartkey === 'promotion') {
        // 【投资&营销】
        if (this.currentMode === 0) {
          indicators = indicators?.filter(ele =>
            [
              'rBurnRatio', // R Burn/GMV
              'bBurnRatio', // B Burn/GMV
            ].includes(ele.key),
          )
        } else {
          indicators = indicators?.filter(ele =>
            [
              'marketOrderRatio', // 营销订单占比
              'promoSalesRatio', // 营销订单贡献GMV占比
              'mktCompletedOrderVolume', // 营销完成订单量
              'mktOrderSales', // 营销订单销售额
              'merchantAvgMktSpend', // 商家单均营销支出
              'mktOrderAvgPrice', // 营销订单客单价
              'roi', // 投入产出比
            ].includes(ele.key),
          )
        }
      } else if (this.data.chartkey === 'service') {
        // 【服务】
        const isFullIndicators = checkIsFullIndicators((indicators || []).map(i => i.key))
        if (isFullIndicators) {
          switch (String(this.currentMode)) {
            // 0【营业时长】
            case '0':
              indicators = indicators.filter(ele =>
                [
                  'onlineDurationAverage', // 日均在线时长(平均日在线时长)
                  'preSetBusinessHours', // 预设置营业时长
                  'connectivity', // 在线率(实际在线时长/营业时间设置时长)
                  'peakOnlineDuration', // 高峰在线时长
                  'onlineRateDuringPeakHours', // 高峰时段在线率 (高峰在线率)
                ].includes(ele.key),
              )
              break
            // 1【取消订单】
            case '1':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'cancelOrderCnt' || // 取消订单量
                  ele.key === 'cancellationRatio' || // B责取消率
                  ele.key === 'cancellationRatio' || // 取消订单量
                  ele.key === 'lostSales', // B责取消订单造成的金额损失
              )
              break
            // 2【问题订单】
            case '2':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'lessWrongOrderCnt' || // 少错餐订单量
                  ele.key === 'lessWrongOrderRate' || // 少错餐率
                  ele.key === 'imperfectOrderCnt' || // 问题订单量
                  ele.key === 'imperfectOrderRatio', // 问题订单率
              )
              break
            // 3【出餐超时】
            case '3':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'deliveryOrdersCnt' || // 出餐超时订单量
                  ele.key === 'mealTimeoutRate', // 出餐超时率
              )
              break
            default:
              break
          }
        } else {
          switch (String(this.currentMode)) {
            // 0【取消订单】
            case '0':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'cancelOrderCnt' || // 取消订单量
                  ele.key === 'cancellationRatio' || // B责取消率
                  ele.key === 'cancellationRatio' || // 取消订单量
                  ele.key === 'lostSales', // B责取消订单造成的金额损失
              )
              break
            // 1【问题订单】
            case '1':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'lessWrongOrderCnt' || // 少错餐订单量
                  ele.key === 'lessWrongOrderRate' || // 少错餐率
                  ele.key === 'imperfectOrderCnt' || // 问题订单量
                  ele.key === 'imperfectOrderRatio', // 问题订单率
              )
              break
            // 2【出餐超时】
            case '2':
              indicators = indicators.filter(
                ele =>
                  ele.key === 'deliveryOrdersCnt' || // 出餐超时订单量
                  ele.key === 'mealTimeoutRate', // 出餐超时率
              )
              break
            default:
              break
          }
        }
      }
      return indicators
    },
    tagData() {
      let isFullIndicators = true
      if (this.data.chartkey === 'service') {
        // "服务"版块:权限限制判断，是否展示完整的指标
        isFullIndicators = checkIsFullIndicators((this.data?.indicators || []).map(i => i.key))
      }
      return {
        promotion: [
          {
            name: this.$t('FoodB_APP_WsXR_yQpy' /** 投资 */),
          },
          {
            // name: this.$t('FoodB_APP_eiHc_XFQQ' /** 营销占比 */),
            name: this.$t('Gattaran_V1__SttS' /** 营销 */), // BR"营销占比"改为"营销"
          },
          {
            name: this.$t('FoodB_ads_WAjG_IoqX' /** 广告 */), // BD仪表盘增加广告数据
          },
        ],
        service: isFullIndicators
          ? [
              {
                name: this.$t('FoodB_Side_JVcJ_wJec' /** 营业时长 */),
              },
              {
                name: this.$t('FoodB_Side_ZUeL_zYXD' /** 取消订单 */),
              },
              {
                name: this.$t('FoodB_Side_cJSW_giyr' /** 问题订单 */),
              },
              {
                name: this.$t('FoodB_Side_Etep_PIxp' /** 出餐超时 */),
              },
            ]
          : [
              {
                name: this.$t('FoodB_Side_ZUeL_zYXD' /** 取消订单 */),
              },
              {
                name: this.$t('FoodB_Side_cJSW_giyr' /** 问题订单 */),
              },
              {
                name: this.$t('FoodB_Side_Etep_PIxp' /** 出餐超时 */),
              },
            ],
      }
    },
  },
  watch: {
    /**
     * 监听图例项变化
     *
     * 触发时机：
     * - 用户切换图表模式（如投资 ↔ 营销占比）
     * - 图表数据更新导致图例项变化
     *
     * 功能说明：
     * 1. 重置所有图例项为激活状态（全部显示）
     * 2. 重置图例折叠状态和布局参数
     * 3. 重新计算图例布局（是否需要折叠、折叠高度等）
     *
     * 适用范围：
     * 仅对 users（用户）、service（服务）、promotion（投资&营销）三个维度生效
     */
    currentLegendItems() {
      if (['users', 'service', 'promotion'].includes(this.data.chartkey)) {
        // 重置所有图例项为激活状态
        this.legendActive = this.currentLegendItems.map(() => true)
        // 重置为折叠状态
        this.legendCollapsed = true
        // 重置溢出标记
        this.legendHasOverflow = false
        // 重置折叠高度
        this.legendCollapsedHeight = 0
        // 在 DOM 更新后重新计算图例布局
        this.$nextTick(() => {
          this.updateLegendLayout()
        })
      }
    },
    direction() {
      if (['users', 'service', 'promotion'].includes(this.data.chartkey)) {
        this.$nextTick(() => {
          this.updateLegendLayout()
        })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateLegendLayout()
    })
  },
  methods: {
    chooseMode(index) {
      if (this.currentMode !== index) {
        this.currentMode = index
        this.$refs.charts?.setCurrentMode(index)
      }
    },
    // 用于通知图表点击了其他区域，隐藏图表的tooltip
    closeToolTip() {
      EventBus.$emit('handleToolTipClose', '')
    },
    showHorCharts(key) {
      const chartKey = this.isFullChart
        ? chartKeyForHorShow.indexOf(key)
        : normalRoleChartKeyForHorShow.indexOf(key)

      this.$emit('showHorChartsItem', chartKey)
    },

    changeChartMode(key) {
      // 兼容横屏场景：在组件内部实现的chart组件切换chartMode，如“service”版块
      if (this.direction === 'horizontal') {
        this.currentMode = key
      }
    },
    advertiseSelect(data) {
      this.$emit('advertiseSelect', data)
    },
    updateLegendLayout() {
      if (
        this.direction !== 'vertical' ||
        !['users', 'service', 'promotion'].includes(this.data.chartkey)
      ) {
        this.legendHasOverflow = false
        this.legendCollapsedHeight = 0
        return
      }

      const legendList = this.$refs.legend?.$refs.legendList
      if (!legendList) {
        this.legendHasOverflow = false
        this.legendCollapsedHeight = 0
        return
      }

      const items = legendList.children || []
      if (!items.length) {
        this.legendHasOverflow = false
        this.legendCollapsedHeight = 0
        return
      }

      const firstRowTop = items[0].offsetTop
      let firstRowBottom = items[0].offsetTop + items[0].offsetHeight
      let hasOverflow = false

      for (let i = 1; i < items.length; i++) {
        const item = items[i]
        if (item.offsetTop > firstRowTop) {
          hasOverflow = true
          break
        }
        firstRowBottom = Math.max(firstRowBottom, item.offsetTop + item.offsetHeight)
      }

      this.legendHasOverflow = hasOverflow
      this.legendCollapsedHeight = hasOverflow ? firstRowBottom - firstRowTop : 0
      if (!hasOverflow) {
        this.legendCollapsed = true
      }
    },
    toggleLegendCollapse() {
      if (!this.legendHasOverflow) return
      this.legendCollapsed = !this.legendCollapsed
    },
    handleLegendToggle({ index, name }) {
      this.toggleLegend(index, name)
    },
    toggleLegend(index) {
      const next = [...this.legendActive]
      next[index] = !next[index]
      // 至少保留一个激活
      if (next.some(Boolean)) {
        this.legendActive = next
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.diagnosis-item-wrap {
  position: relative;
  margin-top: 1px;
  padding: 24px;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  /* 巴西竖向：外层不占白底与分割线，由内层卡片承担 */
  &.diagnosis-item-wrap-br:not(.diagnosis-item-wrap-hor) {
    padding: 0;
    margin-top: 0;
    margin-bottom: 24px;
    background: transparent;
    border: none;
  }

  &__panel--card {
    background: #ffffff;
    border-radius: 32px;
    padding: 32px;
    box-sizing: border-box;
  }

  &__panel--hor {
    padding: 0;
    margin: 0;
    background: transparent;
  }

  .period-filter-wrap {
    margin-bottom: 32px;
  }

  .tips {
    position: relative;
    display: flex;
    margin-top: 24px;
    align-items: flex-start;
    line-height: 28px;
    margin-bottom: 12px;

    i {
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: #8d9099;
      margin-right: 4px;
      font-size: 20px;
    }

    span {
      line-height: 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #8d9099;
      font-weight: 400;
      flex: 1;
    }
  }

  .action-container {
    position: relative;
    margin-top: 24px;
    background-image: linear-gradient(180deg, #fff8f3 0%, #ffffff 100%);
    padding: 16px 24px 8px;
    .action-title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #f76a31;
      line-height: 36px;
      font-weight: 600;
    }

    .action-wrap {
      position: relative;
      .action-item {
        position: relative;
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
        margin-bottom: 24px;
        i {
          display: block;
          width: 16px;
          height: 16px;
          opacity: 0.5;
          border: 3px solid #f76a31;
          margin-right: 16px;
          box-sizing: border-box;
          border-radius: 16px;
          margin-top: 8px;
        }

        p {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #595c66;
          line-height: 32px;
          font-weight: 400;
        }
      }
    }
  }
}
.diagnosis-item-wrap-hor {
  margin-top: -20px;
  margin-left: 10px;
  padding-top: 0;
  overflow-y: auto;
  height: calc(100% - 100px);
}
.chart-mode-choose {
  display: flex;
  margin: 40px 0 40px 0;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .mode-tag {
    height: 32px;
    background: #f2f2f5;
    border-radius: 16px;
    padding: 8px 16px;
    margin-right: 24px;
    margin-bottom: 0;
    font-family: DiDi Sans Pro;
    font-size: 24px;
    font-weight: 500;
    flex-shrink: 0;
    white-space: nowrap;
    p {
      line-height: 32px;
      color: #0c0c0d;
      white-space: nowrap;
    }
  }
  .mode-selected {
    background: #0c0c0d;
    p {
      font-family: DiDiSans-pro-Regular;
      color: #fff;
      font-weight: bold;
    }
  }
}
// 横屏优化
.chart-mode-choose-hor {
  margin: 32px auto;
}
</style>
